import { Col, Form, Input, Row, Select } from "antd";
import { FC } from "react";

type ReasonOfResubmissionCghsNewProps = {
  reasonOfResubmissionForm: any;
  resubmissionReasonOptions: Array<{ label: string; value: string }>;
};

const ReasonOfResubmissionCghsNew: FC<ReasonOfResubmissionCghsNewProps> = (
  props
) => {
  return (
    <div style={{ marginTop: "2rem" }}>
      <Form form={props?.reasonOfResubmissionForm} layout="vertical">
        <Row gutter={[16, 16]} align="top">
          <Col span={8}>
            <Form.Item
              label="Resubmission Reason"
              name="resubmissionReason"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              rules={[
                {
                  required: true,
                  message: "Select Resubmission Reason",
                },
              ]}
            >
              <Select
                options={props?.resubmissionReasonOptions}
                placeholder="Select Resubmission Reason"
                showSearch
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="Remarks"
              name="remarks"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
              rules={[
                {
                  required: true,
                  message: "Enter Remarks",
                },
              ]}
            >
              <Input
                style={{ borderRadius: "5px" }}
                placeholder="Enter Remarks"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ReasonOfResubmissionCghsNew;
